import BranchDCBReportActionTypes from './branch-DCB-report.types';

/** ***************** GET BRANCH DCB REPORT START *********************** */
export const getBranchDCBReportDetailsStart = (getData: any) => ({
	type: BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_START,
	payload: getData,
});

export const getBranchDCBReportDetailsSuccess = (successData: any) => ({
	type: BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getBranchDCBReportDetailsFailure = (failureData: any) => ({
	type: BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getBranchDCBReportDetailsResponseResetStart = () => ({
	type: BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_RESPONSE_RESET,
});

export const getBranchDCBReportDetailsResponseChanged = () => ({
	type: BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH DCB REPORT END *********************** */
